<template>
  <section>
    <div>
      <h4>Das alles ist bei jeder clickzip Website inklusive:</h4>
      <ul>
        <li>Responsive Webdesign</li>
        <li>Einzigartiges Design exakt nach Ihren Vorgaben</li>
        <li>Content Management System</li>
        <li>Persönlicher Ansprechpartner über den gesamten Projektzeitraum</li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InclusiveFooter'
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";
section {
  padding: 40px 15px 30px 15px;
  width: 100%;
  display: flex;
  div {
    margin: auto;
    h4 {
      font-family: $primaryFont;
      color: $secondaryHeadingColor;
      font-weight: $primaryFontBold;
      font-size: 18px;
      margin-bottom: 15px;
    }
    ul {
      font-family: $secondaryFont;
      font-weight: $secondaryFontNormal;
      color: $secondaryFontColor;
      margin: 0;
      padding: 0 0 0 20px;
      li {
        list-style: none;
        position: relative;
        font-size: 16px;
        margin-bottom: 4px;
      }
      li:before {
        content:'';
        display:inline-block;
        background-position:center center;
        background-repeat:no-repeat;
        margin-right:8px;
        position: absolute;
        top: 6px;
        left: -20px;
        width: 14px;
        height: 14px;
        background-image: url('../assets/img/icons/listCheck.svg');
      }
    }
  }
}
@media (min-width:767px) {
  section {
    padding: 60px 40px 50px 40px;
    div {
      h4 {
        font-size: 20px;
      }
      ul {
        li {
        }
      }
    }
  }
}
</style>
